import Styles from './ListContainer.module.scss';

const ListContainer = ({ children }) => {
  return <div className={Styles.discussionsList}>{children}</div>;
};

ListContainer.propTypes = {};

export default ListContainer;
